import type { AxiosError, AxiosResponse } from 'axios';

const maskString = (stringToMask?: string) => {
  return `*** masked - ${stringToMask?.length ? stringToMask.length : 'undefined'} chars ***`;
};

export function maskAuthStringsInError(
  errorResponse: AxiosError<unknown, any> & {
    config: {
      ignoreProfilingInterceptor: boolean;
      ignoreErrorInterceptor: boolean;
      ssrtid: string;
      endpoint: string;
      userAgent: string;
      token: string;
      xForwardedFor: string;
    };
  } & AxiosResponse<any, any>
) {
  if (errorResponse.isAxiosError) {
    if (errorResponse?.request?._header) {
      errorResponse.request._header = maskString(errorResponse.request._header);
    }
    if (errorResponse?.config?.headers?.['Authorization']) {
      errorResponse.config.headers['Authorization'] = maskString(
        errorResponse.config.headers['Authorization'].toString?.()
      );
    }
    if (errorResponse?.config?.headers?.['sessionticket']) {
      errorResponse.config.headers['sessionticket'] = maskString(
        errorResponse.config.headers['sessionticket'].toString?.()
      );
    }
    if (errorResponse?.response?.config?.headers?.['sessionticket']) {
      errorResponse.response.config.headers['sessionticket'] = maskString(
        errorResponse.response.config.headers['sessionticket'].toString?.()
      );
    }
  }
}
